<div class="desktop-content" *ngIf="!isMobile">
  <!-- start : top content -->
  <button
    mat-mini-fab
    fxHide="on"
    class="scroll-up"
    color="primary"
    aria-label="Retour en haut"
  >
    <mat-icon>arrow_upward</mat-icon>
  </button>
  <div class="top-content">
    <!-- ? background div : start -->
    <video
      #video
      autoplay
      muted
      loop
      playsinline
      class="main-background"
      (canplay)="video.play()"
      (loadedmetadata)="video.muted = true"
    >
      <source src="assets/MyBalade_home_video.mp4" type="video/mp4" />
    </video>
    <!-- ? background div : end -->
    <!-- ? main logo div : start -->
    <div class="main-logo">
      <div class="main-logo-img">
        <img src="assets/logos/logo_home.png" alt="Logo Val d‘Oise" />
      </div>
      <div class="upper title slide-in">
        <h1>{{ 'mainTitle' | translate }} Val d‘Oise</h1>
      </div>
      <button class="main-suggestion-button">
        <a
          (click)="sendGaEvent('-', 'Suggestion')"
          routerLink="suggestions"
          aria-label="Vers inspiration"
        >
          <mat-icon class="custom-icon" svgIcon="inspiration"></mat-icon>
          <p>Suggestions de balade</p>
        </a>
      </button>
    </div>
    <!-- ? main logo div : end -->
    <!-- ? button list div : start -->

    <!-- ? button list div : end -->
  </div>
  <a
    (click)="scrollTo('explore-cnt')"
    *ngIf="currentScreenHeight > 850"
    class="home-arrow link-cursor"
  >
    <p class="home-subtitle-h3">{{ 'arrowText' | translate }}</p>
    <img
      src="assets/images/icon_home_scroll5x.png"
      alt="arrow bottom"
      aria-hidden="true"
    />
  </a>
  <div class="download-button-list">
    <!-- ? GA : Google Play ? -->
    <a
      href="https://play.google.com/store/apps/details?id=com.irealite.mybalade"
      (click)="sendGaEvent('Google Play', 'Play Store')"
      target="_blank"
    >
      <img
        src="assets/icons/btn_googleStore.png"
        class="store-btn"
        alt="logo google store"
      />
    </a>
    <!-- ? GA : Google Play ? -->
    <div fxFlex=""></div>
    <!-- ? GA : AppStore ? -->
    <a
      href="https://apps.apple.com/us/app/valdoise-mybalade/id990253291?l=fr&ls=1"
      (click)="sendGaEvent('AppStore', 'Play Store')"
      target="_blank"
      ><img
        src="assets/icons/btn_appleStore.png"
        class="store-btn"
        alt="logo apple store"
      />
    </a>
    <!-- ? GA : AppStore ? -->
  </div>
  <div id="explore-cnt" class="explore-content">
    <div class="news" [hidden]="hidden">
      <h2 class="explore-title">{{ 'NewsTitle' | translate }}</h2>
      <div class="news-card">
        <div>
          <mat-expansion-panel
            class="news-card-content"
            id="expension-info-panel"
          >
            <mat-expansion-panel-header (click)="clickPanel()">
              <mat-panel-title class="div-image">
                <img
                  class="home-message-image"
                  [src]="homeMessage?.imageBig"
                  alt="Image actualité"
                />
                <h3 style="text-align: center">{{ homeMessage?.title }}</h3>
                <p class="more-subtitle home-subtitle-h5">
                  {{ 'More' | translate }}
                </p>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div
              fxFlex=""
              class="new-desc"
              [innerHTML]="homeMessage?.description"
            ></div>
          </mat-expansion-panel>
        </div>
      </div>
    </div>
    <!-- end : new content -->
    <!-- start : discover content -->
    <div class="explore-div">
      <div class="wave-img">
        <img src="assets/images/wave.png" alt="wave" aria-hidden="true" />
      </div>

      <h2 class="explore-title" translate="Explore"></h2>

      <mat-grid-list
        class="explore-card-wrapper"
        cols="4"
        [rowHeight]="responsiveCardSizeValue"
      >
        <!-- ? tile card n°1 : start -->
        <mat-grid-tile colspan="1">
          <mat-card fxFlex="" class="explore-card" routerLink="/carte/0">
            <img
              mat-card-image
              class="explore-image"
              src="{{ images.Heritages }}"
              alt="{{ 'heritageImg' | translate }}"
            />
            <div class="explore-card-title">
              <mat-card-title
                fxFlex=""
                class="explore-subtitle upper"
                translate="Heritages"
              ></mat-card-title>
              <mat-icon svgIcon="icon_Heritages" color="primary"></mat-icon>
            </div>
          </mat-card>
        </mat-grid-tile>
        <!-- ? tile card n°1 : end -->
        <!-- ? tile card n°2 : start -->
        <mat-grid-tile colspan="1">
          <mat-card fxFlex="" class="explore-card" routerLink="/carte/1">
            <img
              mat-card-image
              class="explore-image"
              src="{{ images.Circuits }}"
              alt="{{ 'heritageImg' | translate }}"
            />
            <div class="explore-card-title">
              <mat-card-title
                fxFlex=""
                class="explore-subtitle upper"
                translate="Circuits"
              ></mat-card-title>
              <mat-icon svgIcon="icon_Circuits" color="primary"></mat-icon>
            </div>
          </mat-card>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <mat-card fxFlex="" class="explore-card" routerLink="/carte/3">
            <img
              mat-card-image
              class="explore-image"
              src="{{ images.Events }}"
              alt="{{ 'heritageImg' | translate }}"
            />
            <div class="explore-card-title">
              <mat-card-title
                fxFlex=""
                class="explore-subtitle upper"
                translate="Events"
              ></mat-card-title>
              <mat-icon svgIcon="icon_Events" color="primary"></mat-icon>
            </div>
          </mat-card>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <mat-card fxFlex="" class="explore-card" routerLink="/carte/2">
            <img
              mat-card-image
              class="explore-image"
              src="{{ images.Services }}"
              alt="{{ 'heritageImg' | translate }}"
            />
            <div class="explore-card-title">
              <mat-card-title
                fxFlex=""
                class="explore-subtitle upper"
                translate="Services"
              ></mat-card-title>
              <mat-icon svgIcon="icon_Services" color="primary"></mat-icon>
            </div>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
    <!-- end : discover content -->
  </div>

  <!-- end : explore content -->
  <div class="to-top-container">
    <button
      class="to-top"
      mat-mini-fab
      (click)="scrollToTop()"
      color="primary"
      aria-label="retour en haut"
    >
      <mat-icon>arrow_upward</mat-icon>
    </button>
  </div>
</div>

<div *ngIf="isMobile">
  <div class="sp-content">
    <div class="top-content-sp">
      <video
        #video
        autoplay
        muted
        loop
        playsinline
        class="main-background-sp"
        (canplay)="video.play()"
        (loadedmetadata)="video.muted = true"
      >
        <source src="assets/MyBalade_home_video.mp4" type="video/mp4" />
      </video>

      <div class="main-logo-sp">
        <div class="main-logo-img-sp">
          <img src="assets/logos/logo_home.png" alt="Logo Val d‘Oise" />
        </div>
        <div class="title upper slide-in">
          <p class="home-subtitle-h3">
            {{ 'mainTitle' | translate }} <b>Val d‘Oise</b>
          </p>
        </div>
        <button class="main-suggestion-button-sp">
          <a
            (click)="sendGaEvent('-', 'Suggestion')"
            routerLink="suggestions"
            aria-label="Vers inspiration"
          >
            <mat-icon class="custom-icon" svgIcon="inspiration"></mat-icon>
            <p>Suggestions de balade</p>
          </a>
        </button>
      </div>

      <a (click)="scrollTo('explore-sp-anchor')" class="home-arrow-sp">
        <p class="home-subtitle-h3">{{ 'arrowText' | translate }}</p>
        <img
          src="assets/images/icon_home_scroll5x.png"
          alt="arrow bottom"
          aria-hidden="true"
        />
      </a>
      <!-- download button div-->
      <div class="download-button-list-sp dl-first-sp">
        <!-- ? GA : Google Play ? -->
        <a
          href="https://play.google.com/store/apps/details?id=com.irealite.mybalade"
          (click)="sendGaEvent('Google Play', 'Play Store')"
          target="_blank"
        >
          <img
            src="assets/icons/btn_googleStore.png"
            class="store-btn-sp"
            alt="Logo google store"
          />
        </a>
        <!-- ? GA : Google Play ? -->
        <!-- ? GA : AppStore ? -->
        <a
          href="https://apps.apple.com/us/app/valdoise-mybalade/id990253291?l=fr&ls=1"
          (click)="sendGaEvent('AppStore', 'Play Store')"
          target="_blank"
          ><img
            src="assets/icons/btn_appleStore.png"
            class="store-btn-sp"
            alt="logo apple store"
          />
        </a>
        <!-- ? GA : AppStore ? -->
      </div>
    </div>
    <div class="news-sp" [hidden]="hidden">
      <h3 class="explore-title title-sp">{{ 'NewsTitle' | translate }}</h3>
      <div class="news-card-sp">
        <div>
          <mat-expansion-panel class="news-card-content">
            <mat-expansion-panel-header>
              <mat-panel-title class="div-image">
                <img
                  class="home-message-image"
                  [src]="homeMessage?.imageBig"
                  alt="Image actualité"
                />
                <h3 style="text-align: center">{{ homeMessage?.title }}</h3>
                <p class="more-subtitle home-subtitle-h5">
                  {{ 'More' | translate }}
                </p>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div
              fxFlex=""
              class="new-desc"
              [innerHTML]="homeMessage?.description"
            ></div>
          </mat-expansion-panel>
        </div>
      </div>
    </div>
    <div id="explore-sp-anchor" class="explore-content-sp">
      <div class="wave-img">
        <img src="assets/images/wave.png" alt="wave" aria-hidden="true" />
        <h3 class="title-sp" translate="Explore"></h3>
      </div>

      <div>
        <div class="carrousel-sp">
          <!--          -->
          <div routerLink="/carte/0" class="explore-div-sp">
            <img
              class="explore-img-sp"
              src="{{ exploreData[0].image }}"
              alt="{{ exploreData[0].name }}"
            />
            <div class="explore-title-sp">
              <h3 class="explore-ttl-sp" mat-card-title>
                {{ exploreData[0].name | translate }}
              </h3>
              <mat-icon svgIcon="icon_Heritages" color="primary"></mat-icon>
            </div>
          </div>
          <!--          -->
          <div routerLink="/carte/1" class="explore-div-sp">
            <img
              class="explore-img-sp"
              src="{{ exploreData[1].image }}"
              alt="{{ exploreData[1].name }}"
            />
            <div class="explore-title-sp">
              <h3 class="explore-ttl-sp" mat-card-title>
                {{ exploreData[1].name | translate }}
              </h3>
              <mat-icon svgIcon="icon_Circuits" color="primary"></mat-icon>
            </div>
          </div>
          <!--          -->
          <div routerLink="/carte/3" class="explore-div-sp">
            <img
              class="explore-img-sp"
              src="{{ exploreData[3].image }}"
              alt="{{ exploreData[3].name }}"
            />
            <div class="explore-title-sp">
              <h3 class="explore-ttl-sp" mat-card-title>
                {{ exploreData[3].name | translate }}
              </h3>
              <mat-icon svgIcon="icon_Events" color="primary"></mat-icon>
            </div>
          </div>
          <!--          -->
          <div routerLink="/carte/2" class="explore-div-sp">
            <img
              class="explore-img-sp"
              src="{{ exploreData[2].image }}"
              alt="{{ exploreData[2].name }}"
            />
            <div class="explore-title-sp">
              <h3 class="explore-ttl-sp" mat-card-title>
                {{ exploreData[2].name | translate }}
              </h3>
              <mat-icon svgIcon="icon_Services" color="primary"></mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="to-top-container">
      <button
        class="to-top"
        mat-mini-fab
        (click)="scrollToTop()"
        color="primary"
        aria-label="Retour en haut"
      >
        <mat-icon>arrow_upward</mat-icon>
      </button>
    </div>
  </div>

  <div class="footer-sp">
    <!-- ? GA : Partenaire ? -->
    <a
      fxFlex=""
      class="footer-sp-link"
      routerLink="about/partenaires"
      translate="Partners"
    ></a>
    <!-- ? GA : Partenaire ? -->
    <mat-divider [vertical]="true"></mat-divider>

    <div class="logo-grid">
      <!-- ? GA : Partenaire ? -->
      <a
        href="https://www.valdoise.fr/"
        (click)="
          sendGaEvent('url', 'Site Web Extérieur', 'https://www.valdoise.fr/')
        "
        target="_blank"
      >
        <img
          class="logo-foot-sp"
          src="assets/logos/logo_Val_Oise.png"
          alt="Logo Val d‘Oise"
        />
      </a>
      <!-- ? GA : Partenaire ? -->
      <!-- ? GA : Partenaire ? -->
      <!-- <a href="https://www.iledefrance.fr/" (click)="sendGaEvent('Partenaire', 'Ile de France')" target="_blank">
        <img class="logo-foot-sp" src="assets/logos/ridf.jpg" alt="logo région Ile de France" />
      </a> -->
      <!-- ? GA : Partenaire ? -->
      <!-- ? GA : Partenaire ? -->
      <!-- <a
        href="https://www.culture.gouv.fr/"
        (click)="sendGaEvent('Partenaire', 'Ministère de la Culture et de la Communication')"
        target="_blank"
      >
        <img class="logo-foot-sp" src="assets/logos/LogoMCHP.png" alt="Logo ministère de la culture" />
      </a> -->
      <!-- ? GA : Partenaire ? -->
      <!-- ? GA : Partenaire ? -->
      <a
        href="https://www.gouvernement.fr/les-priorites/france-relance"
        (click)="
          sendGaEvent(
            'url',
            'Site Web Extérieur',
            'https://www.gouvernement.fr/les-priorites/france-relance'
          )
        "
        target="_blank"
      >
        <img
          class="logo-foot-sp"
          src="assets/logos/Logo France Relance_2.png"
          alt="logo France Relance"
        />
      </a>
      <!-- ? GA : Partenaire ? -->
      <!-- ? GA : Partenaire ? -->
      <a
        href="https://commission.europa.eu/strategy-and-policy/recovery-plan-europe_fr"
        (click)="
          sendGaEvent(
            'url',
            'Site Web Extérieur',
            'https://commission.europa.eu/strategy-and-policy/recovery-plan-europe_fr'
          )
        "
        target="_blank"
      >
        <img
          class="logo-foot-sp logo-foot-sp-rectangle"
          src="assets/logos/FR Finance par Union europenne_Horizontal2.png"
          alt="logo Union Européeene"
        />
      </a>
      <!-- ? GA : Partenaire ? -->
    </div>
  </div>
</div>
